import React from 'react'
import _ from 'lodash'
import styled from 'styled-components'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import {
  fetchBanners,
  deleteBanner,
  updateBanners,
} from '../../../modules/portal-remote/portalService'
import { toast } from 'react-toastify'
import { TOWN_BANNER_ITEM_MODAL } from '../../../constants/modalType'
import withReduxModal from '../../../modules/redux-modal/redux/withReduxModal'
import config from '../../../config'
import { setBanners } from '../../../actions/banners'
import {
  SortableContainer,
  SortableElement,
  arrayMove,
} from 'react-sortable-hoc'
import withLanguage from '../lang-select/withLanguage'
import ImageSize from '../image-preview/ImageSize'

class BannerListContainer extends React.Component {
  componentDidMount() {
    this.requestBanner()
  }

  requestBanner = async () => {
    try {
      const townID = _.get(this.props, 'params.townID')
      const banners = await fetchBanners(townID)
      this.props.actions.setBanners(banners)

      // this.handleBannerSelect(banners[0])
    } catch (error) {
      toast.error(error.message)
    }
  }

  onSortEnd = ({ oldIndex, newIndex, ...rest }) => {
    const newBanners = arrayMove(this.props.banners, oldIndex, newIndex)

    if (!_.isEqual(this.props.banners, newBanners)) {
      this.handleValueChange(newBanners)
    }
  }

  handleValueChange = async _banners => {
    const banners = _.map(_banners, (banner, index) => {
      return {
        _id: banner._id,
        appearSeq: index + 1,
      }
    })

    try {
      await updateBanners(banners)
      this.requestBanner()
      toast.success('Update Banners Compelete.')
    } catch (error) {
      toast.error('Update Banners Error: ' + error.message)
    }
  }

  handleBannerSelect = banner => {
    this.props.modalActions.showModal(TOWN_BANNER_ITEM_MODAL, {
      bannerID: banner._id,
    })
  }

  handleBannerDelete = async banner => {
    try {
      if (
        window.confirm(`Are you sure delete ${_.get(banner, 'title.th')} ?`)
      ) {
        await deleteBanner(banner._id)
        await this.requestBanner()
        toast.success(`Remove ${_.get(banner, 'title.th')}`)
      }
    } catch (error) {
      toast.error(error.message)
    }
  }

  render() {
    if (_.isEmpty(this.props.banners)) {
      return null
    }

    return (
      <div className="container">
        <SortableList
          pressDelay={100}
          items={this.props.banners}
          language={this.props.language}
          onSortEnd={this.onSortEnd}
          onBannerSelect={this.handleBannerSelect}
          onDelete={this.handleBannerDelete}
        />
      </div>
    )
  }
}

const SortableList = SortableContainer(
  ({ items, onBannerSelect, onDelete, language }) => {
    return (
      <div>
        {_.map(items, (banner, index) => (
          <SortableItem
            key={`item-${index}`}
            index={index}
            banner={banner}
            language={language}
            onBannerSelect={onBannerSelect}
            onDelete={onDelete}
          />
        ))}
      </div>
    )
  },
)

const SortableItem = SortableElement(props => {
  return <BannerItem {...props} />
})

const BannerItem = ({ banner, language = 'th', onBannerSelect, onDelete }) => {
  const imageRef = React.useRef()

  return (
    <BannerItemLayout onClick={() => onBannerSelect(banner)}>
      <div className="column is-3">
        <strong>{_.get(banner, `title.${language}`)}</strong>
      </div>
      <div className="column is-8">
        <BannerImage className="image is-21x9">
          <img
            ref={imageRef}
            key={banner.mainImageLastChecked || banner.mainImageId}
            src={`${config.mainImageURLPrefix}/${
              banner.mainImageId
            }?lastChecked=${banner.mainImageLastChecked}`}
            alt={banner.mainImageId}
          />
          <ImageSize imageRef={imageRef} />
        </BannerImage>
      </div>
      <div className="column is-1">
        <button
          className="delete"
          onClick={e => {
            e.stopPropagation()
            onDelete(banner)
          }}
        />
      </div>
    </BannerItemLayout>
  )
}

const BannerImage = styled.div`
  max-width: 360px;
`

const BannerItemLayout = styled.div.attrs({ className: 'columns box' })`
  // padding: 8px;
  margin: 8px;
  cursor: pointer;
`

export default compose(
  connect(
    ({ banners }) => ({ banners }),
    dispatch => ({
      actions: bindActionCreators({ setBanners: setBanners }, dispatch),
    }),
  ),
  withReduxModal,
  withLanguage,
)(BannerListContainer)



// WEBPACK FOOTER //
// ./src/components/templates/banner-list/BannerListContainer.js